import { ReactNode } from "react";
import { PlanPurchaseConfirmationProps } from "@swiggy-private/dls-web-recipe-common-web/dist/components/SwiggyOne/PlanRemoveConfirmationBottomsheet";
import { PlanDetails } from "./ExtraItem";
import { IRemovePlanMessage } from "./SwiggyOneInfo";
import { ApplyCouponPotentialComms } from "./Coupon";
import { GiftingCouponCode } from "./GiftingCart";

export enum SavingsRightSectionType {
    ICON = "icon",
    BUTTON = "button",
    LABEL = "label",
    LINK = "link",
}

export enum SavingsLineItemButtonType {
    PRIMARY = "primary",
    SECONDARY = "secondary",
}

export interface SavingsLineItemTitle {
    value?: string;
    onClick?: VoidFunction;
    titleNode?: ReactNode;
    showNewTag?: boolean;
}

export interface SavingsLineItemSubtitle {
    value?: string;
    icon?: boolean;
    subtitleNode?: ReactNode;
    onClick?: VoidFunction;
}

export interface SavingsLineItemRightSection {
    type: SavingsRightSectionType;
    value?: string;
    onClick?: VoidFunction;
    buttonType?: SavingsLineItemButtonType;
    color?: string;
}

export interface SavingsLineItemData {
    icon?: string;
    onLoad?: VoidFunction;
    onLineItemClick?: VoidFunction;
    title: SavingsLineItemTitle;
    subtitle?: SavingsLineItemSubtitle;
    rightSection: SavingsLineItemRightSection;
    bottomText?: string;
    bottomSheetProps?: PlanPurchaseConfirmationProps;
    showRemovePlanConfirmation?: boolean;
    planDetails?: PlanDetails;
    footerCommsStrip?: ApplyCouponPotentialComms;
    couponCodeList?: {
        applied?: boolean;
        codes?: GiftingCouponCode[];
        impressionEventCallback?: (couponCode: GiftingCouponCode, applied?: boolean) => void;
    };
    footerType?: string;
}

export interface SavingsLineItemProps {
    removePlanMessage: IRemovePlanMessage;
    SavingsLineItemData: SavingsLineItemData;
}
